









import { Component, Prop } from 'vue-property-decorator';
import Mixin from '@/mixin';
import $ from 'jquery';
import 'jqueryui';

@Component({
  name: 'VDatePicker'
})
export default class VDatePicker extends Mixin {
  @Prop({ required: false }) value?: string;
  @Prop({ required: false }) format?: string;
  @Prop({ required: false }) disabled?: boolean;
  // Format to display on the input component.
  public dateFormatDisplayed = process.env.VUE_APP_DATE_TIME_FORMAT || 'dd/mm/yy';
  // Date Time format to call the API
  public dateFormatApi = process.env.VUE_APP_DATE_TIME_FORMAT_API || 'yy-mm-dd';

  get currentDate() {
    if (this.value) {
      try {
        const dateTime = $.datepicker.parseDate(this.dateFormatApi, this.value);
        const dateString = $.datepicker.formatDate(this.dateFormatDisplayed, dateTime);

        return dateString;
      } catch (error) {
        return null
      }
    }

    return null
  }

  get placeholder() {
    return process.env.VUE_APP_DATE_TIME_PLACE_HOLDER || 'dd/mm/yyyy';
  }

  mounted() {
    $(this.$el).datepicker({
      dateFormat: this.dateFormatDisplayed,
      showButtonPanel: true,
      onSelect: (dateText: string) => {
        if (!dateText) {
          return this.$emit('updated', null);
        }

        const dateTime = $.datepicker.parseDate(this.dateFormatDisplayed, dateText);
        const dateString = $.datepicker.formatDate(this.dateFormatApi, dateTime);
        this.$emit('updated', dateString);
      },
      onClose: (dateText: string) => {
        if (!dateText) {
          return this.$emit('updated', null);
        }

        const dateTime = $.datepicker.parseDate(this.dateFormatDisplayed, dateText);
        const dateString = $.datepicker.formatDate(this.dateFormatApi, dateTime);
        this.$emit('updated', dateString);
      }
    });
  }
}
